import { createSlice } from "@reduxjs/toolkit";

import axios from "axios";


const initialState={
    loading:false,
    data:null
}


export const createFormSlice=createSlice({
    name:"createSlice",
    initialState,
    reducers:{

        createStart: (state)=>{
            state.loading=true
            state.data=null
        },
        createSuccess: (state,action)=>{
            state.loading=false
            state.data=action.payload

        },
        createFail: (state,action)=>{
            state.loading=false
            state.data=action.payload

        }


    }
})


export const {createStart,createSuccess,createFail}=createFormSlice.actions


export const createFormFunc=(val,userId)=>(dispatch)=>{
    console.log(userId,val,"createForm")
let url='http://18.132.190.48:8080/api/v1/form/'
dispatch(createStart())

   return axios.post(`${url}create?userId=${userId}`,val)
    .then((res)=>{
      return   dispatch(createSuccess(res))
    })
    .catch((err)=>{
       return  dispatch(createFail(err))
    })
    // console.log(res)    
   


}


export default createFormSlice.reducer